module.exports = __webpack_public_path__ + "static/media/ipay.30468e60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payment-systems/ipay.png
// module id = 533
// module chunks = 0